import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { FormattedNumberInput } from '@flipster/react/design-utils/formatted-input';
import QuestionCircleIcon from '@flipster/react/icon/generated/QuestionCircleIcon';
import { css } from '@flipster/styled-system/css';
import { flex, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import ErrorMessage from '../ErrorMessage';
import { addPositionModalBunja } from '../state';
import { addPositionValidationBunja } from '../validation-state';
import { addPositionStepBunja } from './state';

const LimitInputSection = () => {
  const { positionAtom, limitPriceAtom, instrumentAtom, isBboAtom } = useBunja(addPositionModalBunja);
  const { limitPriceInputErrorAtom } = useBunja(addPositionValidationBunja);
  const { handleChangeBboChecked } = useBunja(addPositionStepBunja);
  const position = useAtomValue(positionAtom);
  const isBbo = useAtomValue(isBboAtom);
  const instrument = useAtomValue(instrumentAtom);
  const limitPriceInputError = useAtomValue(limitPriceInputErrorAtom);
  const [limitPrice, setLimitPrice] = useAtom(limitPriceAtom);

  return (
    <div className={stack({ px: 16, py: 12, bg: 'background.default.level-1', borderRadius: 8, gap: 6 })}>
      <div className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
        <FormattedMessage id='Trade.r251104.Limit_price' />
      </div>
      <div className={flex({ justify: 'space-between' })}>
        {isBbo ? (
          <div
            className={css({
              textStyle: 'Title/M/Monospace',
              color: 'content.default.level-5',
            })}
          >
            {position.side === 'Long' ? (
              <FormattedMessage id='Trade.r251208.Best_ask' />
            ) : (
              <FormattedMessage id='Trade.r251208.Best_bid' />
            )}
          </div>
        ) : (
          <FormattedNumberInput
            className={css({
              textStyle: 'Title/M/Monospace',
              color: 'content.default.level-5',
            })}
            value={limitPrice}
            precision={instrument.pricePrecision}
            onChange={(value) => {
              setLimitPrice(value || '0');
            }}
          />
        )}
        <div>
          <Checkbox
            css={{ textStyle: 'Text/L/Strong' }}
            checked={isBbo}
            onChange={(e) => handleChangeBboChecked(e.target.checked)}
          >
            <div className={css({ display: 'flex', gap: 4, alignItems: 'center' })}>
              BBO
              <Tooltip placement='bottom-end' shape='white' maxWidth={238}>
                <Tooltip.Trigger css={{ h: 16 }}>
                  <QuestionCircleIcon size={16} color={token('colors.content.default.level-2')} />
                </Tooltip.Trigger>
                <Tooltip.Content>
                  <h6 className={css({ textStyle: 'Text/S/Strong' })}>
                    <FormattedMessage id='Trade.r251104.What_s_bbo' />
                  </h6>
                  <p className={css({ textStyle: 'Text/S/Regular' })}>
                    <FormattedMessage id='Trade.r251104.Limit_price_follows_best_ask_bid_when_buying_selling' />
                  </p>
                </Tooltip.Content>
              </Tooltip>
            </div>
          </Checkbox>
        </div>
      </div>
      {limitPriceInputError && (
        <ErrorMessage type={limitPriceInputError.priority} message={limitPriceInputError.message} />
      )}
    </div>
  );
};

export default LimitInputSection;
